module.exports = __webpack_public_path__ + "assets/img/quickStart-bg.092213d9.png";